import { GET_BANKS_REQUEST, GET_BANKS_SUCCESS, GET_BANKS_FAILURE } from '../types/hotelTypes';

const initState = {
    bankInfo: [],
    loading: false,
    error: false,
    errorMessage: "",
    successMessage: ""
}

const bankReducer = (state = initState, action) => {
    switch(action.type){
        case GET_BANKS_REQUEST:
            // console.log('GET BANKS ', action.payload);
            return {
                ...state,
                loading: true,
                success: false,
                error: false
            }
        case GET_BANKS_SUCCESS:
            // console.log('GET BANKS SUCCESS ', action.payload);
            return {
                ...state,
                success: true,
                loading: false,
                error: false,
                bankInfo: action.payload,
            }
        case GET_BANKS_FAILURE:
            // console.log('GET BANKS FAILURE ', action.payload);
            return {
                ...state,
                loading: false,
                error: true,
                success: false,
                errorMessage: action.payload
            }
        default:
            return state;
    }
}

export default bankReducer;